import PropTypes from 'prop-types';

const telefone = (value) => {
  if (value) {
    const ddd = value.substring(0, 2);
    const quatroPrimeirosNumeros = value.substring(2, 6);
    const quatroUltimosNumeros = value.substring(6, 10);

    return `(${ddd}) ${quatroPrimeirosNumeros}-${quatroUltimosNumeros}`
  };

  return value;
}

telefone.propTypes = {
  value: PropTypes.string.isRequired,
};

const celular = (value) => {
  if (value) {
    const ddd = value.substring(0, 2);
    const cincoPrimeirosNumeros = value.substring(2, 7);
    const quatroUltimosNumeros = value.substring(7, 11);

    return `(${ddd}) ${cincoPrimeirosNumeros}-${quatroUltimosNumeros}`
  };

  return value;
}

celular.propTypes = {
  value: PropTypes.string.isRequired,
};


const cep = (value) => {
  if (value) {
    const cincoPrimeirosNumeros = value.substring(0, 5);
    const tresUltimosNumeros = value.substring(5, 8);

    return `${cincoPrimeirosNumeros}-${tresUltimosNumeros}`
  };

  return value;
}


cep.propTypes = {
  value: PropTypes.string.isRequired,
};



export default {
  telefone, celular, cep
}
